module.exports = require('./dist/component')



// WEBPACK FOOTER //
// ../node_modules/cxs/component.js